/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Direkt/theme';

export const DirektTheme = theme;
